export default __webpack_public_path__ + "static/media/remove_assignee.bda1c0cd.svg";